import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { InfoDialogComponent } from '../dialogs/info-dialog/info-dialog.component';
import { PropagandaDialogComponent } from '../dialogs/propaganda-dialog/propaganda-dialog.component';
import { ResponseDTO } from '../dtos/response-dto';
import { Procedimento } from '../procedimento/procedimento';
import { ProcedimentoConsulta } from '../procedimento/procedimento-consulta/procedimento-consulta';
import { ProcedimentoConsultaService } from '../procedimento/procedimento-consulta/procedimento-consulta.service';
import { ProcedimentoService } from '../procedimento/procedimento.service';
import { TipoMarcacaoEnum } from '../enums/tipo-marcacao-enum';

@Component({
  selector: 'app-pagina-inicial',
  templateUrl: './pagina-inicial.component.html',
  styleUrls: ['./pagina-inicial.component.css']
})
export class PaginaInicialComponent implements OnInit {

  procedimentosConsulta: ProcedimentoConsulta[];

  procedimentos: Procedimento[];

  listaProcedimentosConsultaConcatenados: string = '';

  listaProcedimentosConcatenados: string = '';

  usuarioLogado: ResponseDTO;

  constructor(private procedimentoConsultaService: ProcedimentoConsultaService,
    private procedimentoService: ProcedimentoService,
    private router: Router, private dialog: MatDialog) {

    this.procedimentosConsulta = [];
    this.procedimentos = [];

    this.usuarioLogado = JSON.parse(localStorage.getItem('currentUser') || '{}');
  }

  ngOnInit(): void {
    this.configurarListaDeProcedimentosConsulta();

    this.configurarListaDeProcedimentos();

    //INICIO: Mock criado para simular um usuario logado no sistema.
    /*
    let tipoUsuarioLogado = new UserType();
    tipoUsuarioLogado.id = 2;
    tipoUsuarioLogado.type = 1;
    tipoUsuarioLogado.description = 'Administrador';

    let usuarioLogado: User = new User();
    usuarioLogado.id = 1;
    usuarioLogado.login = 'walberglustosa';
    usuarioLogado.name = 'WALBERG CARIBE BELFORT LUSTOSA';
    usuarioLogado.type = tipoUsuarioLogado;

    sessionStorage.usuarioLogado = JSON.stringify(usuarioLogado);
    */
    //FIM: Mock criado para simular um usuario logado no sistema.

    this.exibirPropaganda();

    this.exibirInfoLocalExameCope();
  }

  configurarListaDeProcedimentosConsulta(): void {
    this.procedimentoConsultaService.listarConsultasDisponiveisDTO()
      .subscribe(data => {
        // console.log(data)
        this.procedimentosConsulta = data;

        for (let procedimentoConsultaAtual of this.procedimentosConsulta) {
          if (procedimentoConsultaAtual && procedimentoConsultaAtual.id) {
            this.listaProcedimentosConsultaConcatenados = this.listaProcedimentosConsultaConcatenados + procedimentoConsultaAtual.nome + ', ';
          }
        }

        if (this.listaProcedimentosConsultaConcatenados &&
          this.listaProcedimentosConsultaConcatenados.indexOf(",") != -1) {
          this.listaProcedimentosConsultaConcatenados =
            this.listaProcedimentosConsultaConcatenados.substring(0, this.listaProcedimentosConsultaConcatenados.length - 2);
        }
      }, error => {
        console.log(error);
      });
  }

  configurarListaDeProcedimentos(): void {
    this.procedimentoService.listarExamesDTO()
      .subscribe(data => {
        // console.log(data)
        this.procedimentos = data;

        for (let procedimentoAtual of this.procedimentos) {
          if (procedimentoAtual && procedimentoAtual.id) {
            this.listaProcedimentosConcatenados = this.listaProcedimentosConcatenados + procedimentoAtual.nome + ', ';
          }
        }

        if (this.listaProcedimentosConcatenados &&
          this.listaProcedimentosConcatenados.indexOf(",") != -1) {
          this.listaProcedimentosConcatenados =
            this.listaProcedimentosConcatenados.substring(0, this.listaProcedimentosConcatenados.length - 2);
        }
      }, error => {
        console.log(error);
      });
  }

  irParaMarcacao(tipoMarcacao: TipoMarcacaoEnum): void {
    this.router.navigate(['/marcacaoConsulta/cadastrarPaciente'], {
      state: {
        tipoMarcacao: tipoMarcacao.toString()
      }
    });

    // const dialogRef = this.dialog.open(InfoDialogComponent, {
    //   data: {
    //     title: 'Atenção',
    //     message: '<b>As seguintes consultas são agendadas de forma presencial:</b>' +
    //       '<br>' +
    //       '<br><li>Avaliação de córnea,</li>' +
    //       '<li>Avaliação de estrabismo,</li>' +
    //       '<li>Avaliação de glaucoma,</li>' +
    //       '<li>Avaliação em oftalmopediatria,</li>' +
    //       '<li>Avaliação de plástica ocular,</li>' +
    //       '<li>Avaliação de retina.</li>'
    //   }
    // });

    // dialogRef.afterClosed().subscribe(result => {
    //   this.router.navigate(['/marcacaoConsulta/cadastrarPaciente'], {
    //     state: {
    //       tipoMarcacao: tipoMarcacao.toString()
    //     }
    //   });
    // });
  }

  irParaAgendamentoDeConsulta(): void {
    this.irParaMarcacao(TipoMarcacaoEnum.TIPO_MARCACAO_CONSULTA);
  }

  irParaAgendamentoDeExame(): void {
    this.irParaMarcacao(TipoMarcacaoEnum.TIPO_MARCACAO_EXAME);
  }

  includeUnidades(): boolean {
    return environment.includeUnidades;
  }

  includeMarcacaoConsultas(): boolean {
    return environment.includeMarcacaoConsultas;
  }

  exibirTextoOtorrino(): boolean {
    return this.isCopeAgenda();
  }

  isCopeAgenda(): boolean {
    return environment.appAlias === 'COPE_AGENDA';
  }

  exibirPropaganda(): void {
    if (environment.exibirPropaganda) {
      this.dialog.open(PropagandaDialogComponent);
    }
  }

  exibirInfoLocalExameCope(): void {
    if (environment.appAlias === 'MARQUE_EXAMES') {
      if (!this.usuarioLogado || !this.usuarioLogado.username) {
        this.dialog.open(InfoDialogComponent, {
          data: {
            title: 'Info ',
            message: "<div class='formatacao-aviso-local'>" +
              "Informamos que, a partir desta data, todos os agendamentos serão realizados exclusivamente no novo portal." +
              "<div class='form-group' style='text-align: center; font-size: 20px;'>" +
              "<a href='https://copeagendamento.com.br'>Clique aqui para acessar</a>" +
              "</div>"


            /*
            message: "<div class='formatacao-aviso-local'>" +
              "Informamos que alguns exames são realizados de forma <b>EXCLUSIVA</b> nas " +
              "unidades específicas, caso não localize o exame solicitado pelo médico naquela " +
              "unidade escolhida, confirme o agendamento e faça o processo novamente " +
              "escolhendo a outra unidade. Alguns exames só podem ser marcados por nossa " +
              "equipe, caso não tenha localizado seus exames favor enviar uma mensagem de " +
              "WhatsApp para (81)994948467 que logo você será atendido.</div> " +
              "<div class='formatacao-aviso-local-endereco'>Cope Boa Vista: Av. Conde da Boa Vista, 1512 - Boa Vista.</div>" +
              "<div class='formatacao-aviso-local-endereco'>Hospital Hapvida Casa Forte: Rua Edson Álvares, 370 - Casa Forte.</div>"
            */
            /*
            message: "<div class='formatacao-aviso-local'>" + 
                        "A partir do dia <b>05/12/2022</b> (segunda feira) todos os exames técnicos deverão " + 
                        "ser agendados diretamente no call center do <b>Hapvida</b>."
            */
            /*
            message: "<div class='formatacao-aviso-local'>Há <b>exames</b> que são realizados exclusivamente em unidades diferentes. <br>" +
              "Caso não ache seu exame em uma unidade, ao finalizar o agendamento realizar a nova marcação para a outra unidade.</div>" +
              "<div class='formatacao-aviso-local-endereco'>Cope Boa Vista: Av. Conde da Boa Vista, 1512 - Boa Vista.</div>" +
              "<div class='formatacao-aviso-local-endereco'>Hospital Hapvida Casa Forte: Rua Edson Álvares, 370 - Casa Forte.</div>"
            */

            /*
            message: "<div class='formatacao-aviso-local'>Os <b>Exames</b> agendados no sistema serão realizados no <b>COPE - Boa Vista.</b></div>" +
            "<div class='formatacao-aviso-local-endereco'>Endereço: Av. Conde da Boa Vista, 1512 - Boa Vista.</div>"
          */
          }
        });
      }
    }
  }

}
